import app from '@/app';

/* @ngInject */
function Resource($resource) {
	return $resource(
		'api/plans/:id',
		{ id: '@id' },
		{
			create: { method: 'POST' },
			query: { method: 'GET' },
			update: { method: 'PUT' }
		}
	);
}

function CacheService() {
	var cache = {};
	return {
		get: function(key) { return cache[key]; },
		set: function(key, value) { cache[key] = value; },
		clear: function(key) { delete cache[key]; }
	};
}

app.factory('UnifilarParameters', Resource);
app.factory('UnifilarParametersCache', CacheService);
